/*
 * view for listing the examples in the quick create example editor
 */

define([
  "marionette",
  "modules/quickCreate/quickExampleModal/quickExamplesList/template/quickExamplesListTemplate.html",
  "modules/quickCreate/quickExampleModal/quickExamplesList/template/quickExampleItemTemplate.html",
], function (Marionette, QuickExamplesListTemplate, QuickExampleItemTemplate) {
  var QuickExamplesListView = {};

  QuickExamplesListView.quickExampleItemView = Marionette.ItemView.extend({
    template: QuickExampleItemTemplate,
    tagName: "tr",
    deselect: function () {
      delete this.model.selected;
      this.render();
    },
    select: function () {
      this.model.selected = true;
      this.render();
    },
    markAsFailure: function () {
      this.model.failure = true;
      this.render();
    },
    unmarkAsFailure: function () {
      delete this.model.failure;
      this.render();
    },
    onRender: function () {
      this.$el.i18n();
      //check if the example is the only example
      if (this.model.collection.size() === 1) {
        this.$el.find("#exampleDelete").html("");
      }
      this.model.entries().once(
        "change",
        function () {
          this.render();
        },
        this,
      );
    },
    triggers: {
      "click #example": "edit:example",
      "click #exampleDelete": "delete:example",
    },
  });

  QuickExamplesListView.quickExamplesListView = Marionette.CompositeView.extend({
    template: QuickExamplesListTemplate,
    itemView: QuickExamplesListView.quickExampleItemView,
    itemViewContainer: "tbody",
    collectionEvents: {
      sort: "_renderChildren",
    },
    onAfterItemAdded: function (itemView) {
      //remove delete button if there is only one entry
      if (this.collection.size() === 1) {
        itemView.$el.find("#exampleDelete").html("");
      }
    },
    onItemRemoved: function (itemView) {
      //remove delete button if there's now only one view (entry)
      if (this.children.length === 1) {
        this.children.first().$el.find("#exampleDelete").html("");
      }
    },
    onRender: function () {
      this.$el.i18n(); //seems to be necessary to explicitly define onRender here for the tooltips to appear.  Odd.
    },
    triggers: {
      "click #addExample": "add:example",
    },
  });

  return QuickExamplesListView;
});
